import "../styles/ContactUs.css"

import Banner from "./navigation/Banner"
import NavBar from "./navigation/NavBar"
import Footer from "./navigation/Footer"

import storeFront from "../images/Welch/Extra/Bar.jpg"

function ContactUs() {
  return (
    <div className="contact-us-page-container" >
      <Banner />
      <NavBar />

      <div className="contact-us-page-content-container">
        <div className="contact-us-content-1">
          <h1>Contact</h1>
        </div>

        <div className="contact-us-content-2">
          <div className="contact-us-info-container">
            <div className="contact-us-info-title">
              <span>Address:</span>
            </div>
            <div className="contact-us-info-content">
              <span>Federal Hill, 310 Atwells Ave. Providence, RI</span>
            </div>
          </div>
          <div className="contact-us-info-container">
            <div className="contact-us-info-title">
              <span>Manager:</span>
            </div>
            <div className="contact-us-info-content">
              <span>Oliver Aldana</span>
            </div>
          </div>
          <div className="contact-us-info-container">
            <div className="contact-us-info-title">
              <span>Phone:</span>
            </div>
            <div className="contact-us-info-content">
              <span>(401)331-5000</span>            
            </div>
          </div>
          <div className="contact-us-info-container">
            <div className="contact-us-info-title">
              <span>Fax:</span>
            </div>
            <div className="contact-us-info-content">
              <span>(401)331-5001</span>            
            </div>
          </div>
          <div className="contact-us-info-container">
            <div className="contact-us-info-title">
              <span>Email:</span>
            </div>
            <div className="contact-us-info-content">
              <span>Romaonthehill@gmail.com</span>            
            </div>
          </div>          
        </div>

        <div className="contact-us-pic">
          <img className="contact-us-coffee-cup" src={storeFront} alt="Coffee cup"/>
        </div>

        <Footer />
        
      </div>
    </div>
  )
}

export default ContactUs
